import * as React from 'react';
import clsx from 'clsx';
import { FullVideoPlayer } from '@/ui/components/fullVideoPlayer/FullVideoPlayer';
import { LocalVideoWithControls } from '@/ui/components/localVideoWithControls/LocalVideoWithControls';
import { PlayArrowIcon } from '@/ui/components/icons/PlayArrowIcon';
import * as styles from './LocalToExternalVideoPlayer.module.scss';

export const LocalToExternalVideoPlayer = ({
  localSrc,
  externalSrc,
  fallbackUrl,
  className,
  videoClassName,
}: {
  localSrc: string;
  externalSrc?: string | null;
  fallbackUrl?: string | null;
  className?: string;
  videoClassName?: string;
}) => {
  const [isShowingExternalVideo, setIsShowingExternalVideo] = React.useState(false);

  return (
    <div className={clsx(styles.video, className)}>
      {fallbackUrl && <img src={fallbackUrl} className={styles.video__fallbackImg} alt="fallback" />}
      {externalSrc && (
        <FullVideoPlayer
          playing={isShowingExternalVideo}
          url={externalSrc}
          className={clsx(
            styles.video__video,
            styles.video__externalVideo,
            !isShowingExternalVideo && styles.video__invisible,
          )}
        />
      )}
      <LocalVideoWithControls
        className={clsx(styles.video__video, isShowingExternalVideo && styles.video__invisible)}
        videoClassName={videoClassName}
        src={localSrc}
        isMuteDisabled={true}
        isPlayDisabled={!localSrc}
      />
      {externalSrc && !isShowingExternalVideo ? (
        <button className={styles.video__playControl} onClick={() => setIsShowingExternalVideo(true)}>
          <PlayArrowIcon />
        </button>
      ) : null}
    </div>
  );
};
